import React from "react";
import { Card, CardContent } from "@heroui/react";
import { Icon } from "@iconify/react/dist/iconify.js";

interface WorkflowDescriptionBubbleProps {
  name: string;
  description: string;
}

/**
 * Displays workflow name and description in an info bubble.
 * Only shown for specialized workflows (not chat_agent) before any messages are sent.
 */
export const WorkflowDescriptionBubble: React.FC<WorkflowDescriptionBubbleProps> = ({
  name,
  description,
}) => {
  return (
    <div className="px-4 py-2">
      <Card className="bg-blue-50 border-blue-200">
        <CardContent className="py-3 px-4">
          <div className="flex items-start gap-2">
            <Icon
              className="text-blue-600 mt-0.5 flex-shrink-0"
              icon="solar:info-circle-bold"
              width={16}
            />
            <div className="text-sm text-blue-800">
              <p className="font-medium mb-1">{name}</p>
              <p className="text-blue-700 whitespace-pre-line">{description}</p>
            </div>
          </div>
        </CardContent>
      </Card>
    </div>
  );
};
